<script lang="ts">
    import { loadStripe } from "@stripe/stripe-js";
    import { Elements, PaymentElement } from "svelte-stripe";
    import { onMount } from "svelte";
    import { PUBLIC_STRIPE_KEY } from "$env/static/public";
    import { ProgressRadial } from "@skeletonlabs/skeleton";
    import Header from "$lib/components/Header.svelte";
    import PencilBlack from "$lib/assets/PencilBlack.svg";

    let stripe_resp;
    let clientSecret_resp;
    let error_message = null;
    let elements;
    let submitting = false;

    async function submit(stripe) {
        submitting = true;
        // ask Stripe to confirm the payment
        const { error } = await stripe.confirmPayment({
            // pass instance that was used to create the Payment Element
            elements,

            // specify where to send the user when payment succeeeds
            confirmParams: {
                return_url: window.location.origin + "/api/payments/complete_payment/scoutwriter",
            },
        });

        if (error) {
            error_message = error;
        }
        submitting = false;
    }

    onMount(() => {
        clientSecret_resp = fetch("/api/payments/create_payment_intent", {
            method: "POST",
            body: JSON.stringify({
                product_type: "scoutwriter",
            }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((res) => {
                return res.client_secret;
            })
            .catch((error) => {
                error_message = error;
            });

        stripe_resp = loadStripe(PUBLIC_STRIPE_KEY);
    });
</script>

{#await Promise.all([clientSecret_resp, stripe_resp])}
    <div class="bg-surface-500 p-5 rounded-lg">
        <header class="font-semibold text-3xl p-5">Loading Payment Portal...</header>
        <ProgressRadial class="m-auto" value={undefined} />
    </div>
{:then arr}
    {@const [clientSecret, stripe] = arr}
    <div class="bg-surface-500 p-5 rounded-lg">
        <Header src={PencilBlack} text={"Subscribe to ScoutWriter"} />
        <div class="flex items-center justify-center mb-3">
            <p class="font-bold text-xl">500$/month</p>
        </div>
        <form
            on:submit|preventDefault={() => {
                submit(stripe);
            }}
        >
            <!-- container for Stripe components -->
            <Elements {stripe} {clientSecret} bind:elements>
                <!-- display payment related fields -->
                <PaymentElement />
            </Elements>

            <div class="flex items-center justify-center">
                <button
                    disabled={submitting}
                    class="rounded-lg py-2 px-4 transition duration-300 hover:shadow-md mt-3 text-white"
                    class:bg-zinc-800={!submitting}
                    class:bg-secondary-500={submitting}
                >
                    Subscribe
                </button>
            </div>
        </form>
    </div>
{:catch}
    <div class="bg-surface-500 p-5 rounded-lg">
        It appears something has gone wrong. Try refreshing the page or contact us if this error persists.
    </div>
{/await}
